import { NOTE_NAMES } from "./constants.js";
import { playNote } from "./audio.js";

export function generateKeyboard(
  audioContext,
  player,
  pianoInstrument,
  handleGuess,
) {
  const keyboard = document.getElementById("keyboard");
  keyboard.innerHTML = "";

  // Get the min and max notes
  const min = parseInt(document.getElementById("minNote").value);
  const max = parseInt(document.getElementById("maxNote").value);

  // Group notes by octave, starting from C
  const octaves = new Map();
  
  for (let midiNote = min; midiNote <= max; midiNote++) {
    // Calculate octave based on C rather than midi note number
    const noteIndex = midiNote % 12;
    const octave = Math.floor((midiNote - noteIndex) / 12) - 1;
    
    // Start a new octave group at C
    if (noteIndex === 0) {
      octaves.set(octave, []);
    }
    
    // Get the current octave group or create it if it doesn't exist
    if (!octaves.has(octave)) {
      octaves.set(octave, []);
    }
    octaves.get(octave).push(midiNote);
  }

  // Create keyboard by octave groups
  octaves.forEach((notes, octave) => {
    const octaveGroup = document.createElement("div");
    octaveGroup.classList.add("octave-group");

    // Sort notes within the octave
    notes.sort((a, b) => a - b);

    // Create keys for this octave
    notes.forEach(midiNote => {
      const noteIndex = midiNote % 12;
      const noteName = NOTE_NAMES[noteIndex];
      const key = document.createElement("div");
      
      key.classList.add("key", noteName.includes("#") ? "black" : "white");
      key.dataset.note = midiNote;
      key.innerText = `${noteName}${octave}`;
      
      key.onclick = () => {
        if (key.classList.contains("enabled")) {
          playNote(audioContext, player, pianoInstrument, midiNote);
          handleGuess(midiNote);
        }
      };
      
      octaveGroup.appendChild(key);
    });

    keyboard.appendChild(octaveGroup);
  });

  updateKeyboard();
}

export function updateKeyboard() {
  let min = parseInt(document.getElementById("minNote").value);
  let max = parseInt(document.getElementById("maxNote").value);
  let excludeBlack = document.getElementById("excludeBlackKeys").checked;

  // Check if we need to regenerate the keyboard
  const existingNotes = new Set(
    Array.from(document.querySelectorAll(".key"))
      .map(key => parseInt(key.dataset.note))
  );

  // If any notes in the range are missing, regenerate the keyboard
  for (let note = min; note <= max; note++) {
    if (!existingNotes.has(note)) {
      // Regenerate the entire keyboard
      generateKeyboard(window.audioContext, window.player, window.currentInstrument, window.handleGuess);
      return;
    }
  }

  // Otherwise just update visibility
  document.querySelectorAll(".key").forEach((key) => {
    let note = parseInt(key.dataset.note);
    let noteIndex = note % 12;
    if (note >= min && note <= max) {
      key.classList.add("enabled");
      key.classList.remove("disabled");
      if (excludeBlack && [1, 3, 6, 8, 10].includes(noteIndex)) {
        key.classList.add("low-opacity");
      } else {
        key.classList.remove("low-opacity");
      }
    } else {
      key.classList.add("disabled");
      key.classList.remove("enabled");
    }
  });
}
